import React from 'react'
import Image from "../../asserts/images/e.png" ;

function Bibliothèque() {
  return (
    <div className='contentimagesDirection'>
    <div className="carteEnseignant">
            <div className='imgcardEnseignant'>
                <img src={Image}></img>
            </div>
            <div className='descr'> 
              <p>Bibliothécaire : <br/> Hajer Abid</p>
              <p id='email1'><i class="fa-regular fa-envelope"></i> abidihajer11@gmail.com</p>
             </div>
    </div>

    <div className="carteEnseignant">
            <div className='imgcardEnseignant'>
                <img src={Image}></img>
            </div>
            <div className='descr'> 
              <p>Conservateur Bibliothécaire : <br/> Sawssen Ben Rejeb</p>
              <p id='email1'><i class="fa-regular fa-envelope"></i> sawssen.benrejeb@gmail.com</p>
            </div>
    </div>
        
       
    </div>
  )
}

export default Bibliothèque